import * as customers from '@appStore/customers/actions/customers.actions';
import * as customerUsers from '@appStore/customers/actions/customer-users.actions';
import * as customerInvitation from '@appStore/customers/actions/customer-invitations.actions';
import * as customerRoles from '@appStore/customers/actions/customer-roles.actions';
import * as customerManagerCompanies from '@appStore/customers/actions/customer-manager-companies.actions';
import * as customersTable from '@appStore/customers/actions/customers-table.actions';
import * as customerAccess from '@appStore/customers/actions/customer-access-requests.actions';
import * as customerApprovals from '@appStore/customers/actions/customer-approvals.actions';

export * from '@appStore/customers/actions/customers.actions';
export * from '@appStore/customers/actions/customer-users.actions';
export * from '@appStore/customers/actions/customer-invitations.actions';
export * from '@appStore/customers/actions/customer-roles.actions';
export * from '@appStore/customers/actions/customer-manager-companies.actions';
export * from '@appStore/customers/actions/customers-table.actions';
export * from '@appStore/customers/actions/customer-access-requests.actions';
export * from '@appStore/customers/actions/customer-approvals.actions';

export const ActionTypes = {
  ...customers.CustomersActionTypes,
  ...customerUsers.CustomerUsersActionTypes,
  ...customerInvitation.CustomerInvitationsActionTypes,
  ...customerRoles.CustomerRolesActionTypes,
  ...customerManagerCompanies.CustomerManagerCompaniesActionTypes,
  ...customersTable.CustomersTableActionTypes,
  ...customerAccess.CustomerAccessRequestsActionTypes,
  ...customerApprovals.CustomerApprovalsActionTypes
};

export type Actions =
  | customers.CustomersActions
  | customerUsers.CustomerUsersActions
  | customerInvitation.CustomerInvitationsActions
  | customerRoles.CustomerRolesActions
  | customerManagerCompanies.CustomerManagerCompaniesActions
  | customersTable.CustomersTableActions
  | customerAccess.CustomerAccessRequestsActions
  | customerApprovals.CustomerApprovalsActions;
